'use client';

import { useIntl } from '@capsicum/common';
import { TabBar } from '@capsicum/common-web';
import { useState } from 'react';

import { SurveyCardList } from '../../ui';

type SurveyListProps = { partnerId: string };

export const SurveyList = ({ partnerId }: SurveyListProps) => {
	const { $t } = useIntl();

	const [selected, setSelected] = useState('currentSurvey');

	const Screens = [
		{
			component: () => (
				<SurveyCardList filterBy="opened" partnerId={partnerId} testID="surveyList-filteredList-list" />
			),
			hasActivityIndicator: false,
			id: 'currentSurvey',
			routeName: 'currentSurvey',
			text: $t('survey.list.current')
		},
		{
			component: () => (
				<SurveyCardList filterBy="closed" partnerId={partnerId} testID="surveyList-filteredList-list" />
			),
			hasActivityIndicator: false,
			id: 'expiredSurvey',
			routeName: 'expiredSurvey',
			text: $t('survey.list.expired')
		}
	];

	return (
		<TabBar
			items={Screens}
			selected={selected}
			testID="surveyList-filter-section"
			variant="fixed"
			onChangeSelected={setSelected}
		/>
	);
};
